export { default as Paste } from './Paste';
